export const IMAGES = {
  heroMockup: 'https://cdn.magicpatterns.com/uploads/v46JsNi7WoprL83Pwu5mgW/mockup_hombre_magnetico_700x700_optimized.webp',
  bundleMockup: 'https://cdn.magicpatterns.com/uploads/vYEUiWbjzsWAjMcvFH8Lr4/MOCKUP_HOMBRE_MAGNETICO.webp'
};
export const PREVIEW_PAGES: {
  src: string;
  alt: string;
}[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/82YGeBU1K9JV1yNRQRi6XE/Captura_de_pantalla_2026-08-29_a_la(s)_10.20.53_a.m..png',
  alt: 'Página interior del Mega Pack sobre confianza sin máscaras'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ij72R6sRJfvBHoGqJB8pby/Captura_de_pantalla_2026-08-29_a_la(s)_10.21.11_a.m..png',
  alt: 'Página interior del Mega Pack sobre necesidad de aprobación'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/r8wiPbf6tewAVuUg9PA61C/Captura_de_pantalla_2026-08-29_a_la(s)_10.21.50_a.m..png',
  alt: 'Página interior del Mega Pack sobre presencia y calma corporal'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/w4QB2jomHGHWdcFk1uJR8N/Captura_de_pantalla_2026-08-29_a_la(s)_10.22.11_a.m..png',
  alt: 'Página interior del Mega Pack con ejercicios prácticos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8EtAo4e3WyPoof5PTMUFcZ/Captura_de_pantalla_2026-08-29_a_la(s)_10.22.57_a.m..png',
  alt: 'Página interior del Mega Pack con el mapa de bloqueos'
}];
export const PRICING = {
  current: 'US$19',
  previous: 'US$49',
  savings: 'US$30'
};
export const BUYER_NAMES: string[] = ['Diego N.', 'Carlos M.', 'Javier T.', 'Martín A.', 'Fernando D.', 'Andrés P.', 'Lucas R.', 'Sergio V.', 'Nicolás C.', 'Álvaro G.'];
export const BUYER_LOCATIONS: string[] = ['Buenos Aires, Argentina', 'Córdoba, Argentina', 'Mendoza, Argentina', 'Madrid, España', 'Barcelona, España', 'Valencia, España', 'Ciudad de México, México', 'Guadalajara, México', 'Monterrey, México', 'Bogotá, Colombia', 'Medellín, Colombia', 'Santiago, Chile', 'Valparaíso, Chile', 'Lima, Perú', 'Arequipa, Perú', 'Montevideo, Uruguay', 'Quito, Ecuador', 'Guayaquil, Ecuador', 'Asunción, Paraguay', 'Santa Cruz, Bolivia', 'San José, Costa Rica', 'Panamá, Panamá', 'Santo Domingo, República Dominicana'];
export const TESTIMONIALS: {
  quote: string;
  name: string;
  location: string;
  avatar: string;
}[] = [{
  quote: 'Yo siempre terminaba en la amistad, aunque sentía que había conexión. Este material me ayudó a entender qué estaba comunicando mal y a mostrar más intención sin verme necesitado.',
  name: 'Daniel M.',
  location: 'Ciudad de México, México',
  avatar: 'https://cdn.magicpatterns.com/uploads/jSdNetEbsBedgd9HVwRFo5/friendly_young_man_headshot.webp'
}, {
  quote: 'Lo que más me sirvió fue dejar de ponerme nervioso y dejar de sobrepensar cada conversación. Empecé a sentirme mucho más natural.',
  name: 'Sergio R.',
  location: 'Madrid, España',
  avatar: 'https://cdn.magicpatterns.com/uploads/8CDGuNaM6ufxZzd1w7Qwsy/warm_smiling_portrait_in_a_neutral_interior.webp'
}, {
  quote: 'Los ejemplos de mensajes me ayudaron muchísimo. Antes mis chats se apagaban rápido; ahora siento que las conversaciones avanzan de verdad.',
  name: 'Nicolás P.',
  location: 'Buenos Aires, Argentina',
  avatar: 'https://cdn.magicpatterns.com/uploads/cyA2w3XL1vWrjDejkezQ1v/friendly_young_man_in_charcoal_knit_sweater.webp'
}, {
  quote: 'El bonus sobre señales de interés me ahorró muchos errores. Dejé de confundirme y empecé a leer mejor cuándo avanzar y cuándo no.',
  name: 'Andrés C.',
  location: 'Bogotá, Colombia',
  avatar: 'https://cdn.magicpatterns.com/uploads/iZ2mnFeAVEseR8nRoGip2A/friendly_bald_man_in_charcoal_henley.webp'
}, {
  quote: 'La parte de primera cita me dio mucha claridad. Fui más tranquilo, hablé mejor y dejé de sentir que tenía que impresionar todo el tiempo.',
  name: 'Javier L.',
  location: 'Lima, Perú',
  avatar: 'https://cdn.magicpatterns.com/uploads/1sURUD5ufxN4VUAesnxvvu/friendly_man_in_khaki_jacket.webp'
}, {
  quote: 'Incluso estando en pareja me ayudó. Mejoré mi comunicación, mi seguridad y la manera en que sostengo la conexión.',
  name: 'Marcos T.',
  location: 'Santiago de Chile',
  avatar: 'https://cdn.magicpatterns.com/uploads/qWobPRyajUeCH8LyFrF3GK/warm_salt_and_pepper_headshot.webp'
}];
export const METRICS: {
  value: string;
  label: string;
}[] = [{
  value: '6',
  label: 'Tomos'
}, {
  value: '5',
  label: 'Bonos'
}, {
  value: '7 días',
  label: "De Garantia"
}, {
  value: '100%',
  label: 'Digital'
}];
export const NOW_LIST: string[] = ['Escuchas durante horas, pero ocultas lo que realmente quieres.', 'Estás disponible siempre que necesita hablar.', 'Analizas cada mensaje antes de responder.', 'Esperas demasiado antes de mostrar interés.', 'Hay conexión emocional, pero todo permanece en amistad.'];
export const AFTER_LIST: string[] = ['Más seguridad al comunicarte.', 'Más claridad para mostrar interés.', 'Mejor lectura de reciprocidad.', 'Menos vínculos ambiguos.', 'Más intención desde el principio.'];
export const SCENES: {
  title: string;
  text: string;
}[] = [{
  title: 'Te cuenta absolutamente todo',
  text: 'Hay confianza y cercanía. Pero cuando parece que podría avanzar, sigue tratándote como un amigo.'
}, {
  title: 'Siempre estás disponible',
  text: 'Escuchas, ayudas y respondes rápidamente, pero el lugar que ocupas nunca termina de quedar claro.'
}, {
  title: 'No sabes cómo mostrar interés',
  text: 'Quieres avanzar, pero dudas entre expresarlo, esperar o terminar forzando una situación.'
}, {
  title: 'Todo funciona… hasta que aparece otro',
  text: 'La conexión parecía avanzar. Después aparece alguien más y surge la misma pregunta: ¿qué faltó?'
}, {
  title: 'Sabes que puedes comunicarte mejor',
  text: 'No necesitas convertirte en otra persona. Necesitas mayor claridad sobre cómo expresar seguridad, intención y límites.'
}];
export const VOLUMES: {
  title: string;
  text: string;
}[] = [{
  title: 'Confianza sin máscaras',
  text: 'Construye seguridad sin fingir ser alguien que no eres. Trabaja aprobación, exceso de análisis y nervios para comunicarte con mayor calma y presencia.'
}, {
  title: 'Más que un amigo',
  text: 'Entiende qué puede convertir una conexión en una dinámica puramente amistosa y cómo expresar interés, límites e intención con mayor claridad.'
}, {
  title: 'Conversaciones que atraen',
  text: 'Mejora la forma de iniciar, mantener y dirigir conversaciones con naturalidad sin depender de frases prefabricadas.'
}, {
  title: 'La cita que cambia todo',
  text: 'Una estructura práctica para desenvolverte con mayor seguridad antes, durante y después de una cita.'
}, {
  title: 'Atracción en pantalla',
  text: 'Mejora tus mensajes, mantén conversaciones con intención y facilita el paso del chat a un encuentro real.'
}, {
  title: 'Después de conquistar',
  text: 'Trabaja comunicación, límites y reciprocidad para construir relaciones sin perder tu propia identidad.'
}];
export const DELIVERY: {
  title: string;
  text: string;
}[] = [{
  title: 'Acceso inmediato',
  text: 'Los 6 tomos y 5 bonos estarán disponibles después de confirmar el pago.'
}, {
  title: 'Desde cualquier dispositivo',
  text: 'Compatible con móvil, tablet y computadora.'
}, {
  title: 'Acceso de por vida',
  text: 'Un pago. Sin suscripciones ni renovaciones.'
}, {
  title: 'Empieza por lo que necesitas',
  text: 'No es necesario leer todo en orden.'
}];
export const PLAN_STEPS: string[] = ['Identifica tu principal bloqueo', 'Aplica un cambio concreto cada día', 'Lleva lo aprendido a situaciones reales', 'Revisa y ajusta'];
export const BONUSES: {
  title: string;
  text: string;
  image: string;
}[] = [{
  title: 'El Radar del Interés',
  text: 'Reconoce señales de interés, comodidad, duda y desinterés.',
  image: 'https://cdn.magicpatterns.com/uploads/mRkotfHkG59ZGVo2SWhyin/Bonus_1-_Radar_de_interes.webp'
}, {
  title: '50 Formas de Iniciar una Conversación',
  text: 'Ideas naturales para iniciar conversaciones sin depender de frases artificiales.',
  image: 'https://cdn.magicpatterns.com/uploads/92G87takxbZi4sxrgn4YFT/Bonus_2_-_50_formas_de_iniciar_una_conversacion.webp'
}, {
  title: 'Mensajes que Avanzan',
  text: 'Ejemplos y estructuras para convertir mensajes en conversaciones que puedan avanzar.',
  image: 'https://cdn.magicpatterns.com/uploads/nyNJJFzsbkLn4wAozBFNHV/Bonus_3_-_Mensajes_que_avanzan.webp'
}, {
  title: 'Plan Primera Cita',
  text: 'Una guía práctica para preparar mejores encuentros.',
  image: 'https://cdn.magicpatterns.com/uploads/j999gdgHk5SVB9P2Wnnw3e/Bonus_4_-_Plan_primera_cita.webp'
}, {
  title: 'Reinicio Emocional',
  text: 'Una estructura para recuperar perspectiva después de rechazo, decepción o ruptura.',
  image: 'https://cdn.magicpatterns.com/uploads/aaWbcqyjRKL3YsXw36PXx2/Bonus_5_-_Reinicio_Emocional.webp'
}];
export const OFFER_ITEMS: {
  label: string;
  value: string;
}[] = [{
  label: 'Mega Pack Hombre Magnético — 6 tomos',
  value: 'US$49'
}, {
  label: 'El Radar del Interés',
  value: 'Incluido'
}, {
  label: '50 Formas de Iniciar una Conversación',
  value: 'Incluido'
}, {
  label: 'Mensajes que Avanzan',
  value: 'Incluido'
}, {
  label: 'Plan Primera Cita',
  value: 'Incluido'
}, {
  label: 'Reinicio Emocional',
  value: 'Incluido'
}, {
  label: 'Garantía de 7 días',
  value: 'Incluida'
}];
export const FAQS: {
  q: string;
  a: string;
}[] = [{
  q: '¿Sirve si ya he quedado como “solo amigo”?',
  a: 'Sí. El Tomo 2 está dedicado precisamente a entender cómo se forma esa dinámica y qué puede cambiar en la manera de comunicar interés, límites e intención. No promete revertir una situación concreta: te da claridad para comunicarte de otra forma desde ahora.'
}, {
  q: '¿Tengo que utilizar frases preparadas?',
  a: 'No. El sistema no se basa en guiones. Trabaja seguridad, presencia y claridad para que la conversación surja de forma natural. Los ejemplos existen como referencia, no como texto para copiar.'
}, {
  q: '¿Tengo que leer los 11 PDFs completos?',
  a: 'No es necesario leerlo todo en orden. Puedes empezar por el tomo que responde a tu bloqueo actual y utilizar el plan de 7 días como punto de partida.'
}, {
  q: '¿Qué puedo esperar durante los primeros 7 días?',
  a: 'Mayor claridad sobre lo que estabas comunicando y un cambio concreto que aplicar cada día. Los resultados dependen de cada persona y cada situación: el material es educativo y no garantiza resultados específicos.'
}, {
  q: '¿Cómo recibo el Mega Pack?',
  a: 'En formato digital, disponible en cuanto se confirme el pago. Se lee desde móvil, tablet o computadora, sin instalar nada.'
}, {
  q: '¿Es una suscripción?',
  a: 'No. Es un pago único de US$19 con acceso de por vida. Sin renovaciones ni cargos posteriores.'
}, {
  q: '¿Y si no es para mí?',
  a: 'Dispones de 7 días para revisarlo. Si consideras que no es para ti, puedes solicitar el reembolso según las condiciones de la plataforma.'
}];